<template>
  <w-sliding-popup ref="slidingPopup" title="장애 예측 분석 스케줄 설정" width="550px" :default-content="false" @close="close">
    <div slot="content" class="body-content-no-scroll" style="height:100%;">
      <div class="vertical-center-box mr-b10">
        <span class="title-h4 dot-title mr-r5">스케줄 정보</span>
        <el-switch v-model="scheduleApplyFlag" active-value="Y" inactive-value="N"/>
      </div>
      <el-row class="mr-b30">
        <span style="color: #47C7B8;">※ 장애 예측 분석 스케줄은 매주 토요일 00시 00분에 자동 실행됩니다.</span>
      </el-row>
      <el-row class="title-bar" type="flex" align="middle">
        <div class="vertical-center-box mr-b10">
          <span class="title-h4 dot-title mr-r5">예측 기간</span>
          <span>(현재 설정된 통계 데이터 보관 주기는 <em>{{this.dataStoragePeriodBasicinfo.year}}</em>년 입니다.)</span>
        </div>
      </el-row>
      <el-row class="mr-b10">
        <span style="color: #47C7B8;">※ 예측기간 허용 범위( {{predictMonth.min}}
          <span v-if="predictMonth.min !== predictMonth.max">~ {{predictMonth.max}}</span> 개월)
        </span>
      </el-row>
      <el-row type="flex" justify="start" align="middle">
        <el-row class="vertical-center-box">
          <el-input-number :disabled="isEditMode" ref="predictPeriodField" class="mr-r10" style="width:95px;" size="mini" v-model="predictPeriod" controls-position="right"
            :min="predictMonth.min" :max="predictMonth.max" :precision="0" @change="onPredictPeriodChange"/>
          <span class="mr-r5">개월</span>
          <span>(예측기간: {{predictDatetimeRange}})</span>
        </el-row>
      </el-row>
    </div>
    <el-row slot="footer" type="flex" justify="center">
      <el-button class="mr-r4" type="solid" size="large" @click="onClickSaveButton">저장</el-button>
      <el-button size="large" @click="close">취소</el-button>
    </el-row>
  </w-sliding-popup>
</template>

<script>
import moment from 'moment';
import { isNil, cloneDeep } from 'lodash';
import { removeTime, getDateToString } from '@/utils/date';
import predictPerfUtil from '@/utils/predict-performance';
import msgUtil from '@/utils/message';
import EventRptApi from '@/api/event/event-rpt';
import WPredictAnalysisPeriodSettingComponent from '../PredictAnalysisPeriodSettingComponent';

export default {
  name: 'WPredictAnalysisScheduleSettingPopup',
  components: {
    WPredictAnalysisPeriodSettingComponent,
  },
  props: {
    periodInfo: {
      type: Object,
    },
  },
  data() {
    return {
      predictDatetimeRange: null,
      tableRow: {},
      learnDataSet: [],
      predictMonth: {
        min: 3,
        max: 6,
      },
      predictPeriod: 3,
      formData: {},
      startDatetime: removeTime(new Date()),
      scheduleApplyFlag: 'N',
      dataStoragePeriodBasicinfo: { year: null }, // 데이터 보관 주기 객체
    };
  },
  mounted() {

  },
  computed: {
    isEditMode() {
      // return (!isEmpty(this.periodInfo) && this.scheduleData.SCHEDULE_APPLY_FLAG === 'N');
      return this.scheduleApplyFlag === 'N';
    },
  },
  methods: {
    /**
     * 스케줄 값 세팅 및 가공
     * @author Song
     */
    open(row) {
      this.$refs.slidingPopup.open();
      this.$nextTick(() => {
        if (row) {
          this.tableRow = cloneDeep(row);
          this.scheduleApplyFlag = row.scheduleRepeatFlag;
          if (row.learnDataSet !== '' && !isNil(row.learnDataSet)) {
            const jsonData = JSON.parse(row.learnDataSet);
            this.predictPeriod = cloneDeep(Math.round(Number(jsonData[0].learnDayCount) / 180)); // 개월 수
          }
        }
        this.getDataStoragePeriod();
      });
    },
    close() {
      this.initData();
      this.$refs.slidingPopup.visible = false;
    },
    /**
     * 초기화
     * @author Song
     */
    initData() {
      this.scheduleApplyFlag = 'N';
      this.predictPeriod = 3;
      this.learnDataSet = [];
      this.predictDatetimeRange = null;
    },
    /**
     * 장애 예측 분석(LTPD) 주기 설정 저장
     * 주기 설정 저장: predict_custom_learn_data에서 event_rpt_predict_flag가 'Y'인 대상들 일괄 업데이트 실시
     * 참고: 시뮬레이션 예측
     *
     * @author Song
     */
    onClickSaveButton() {
      // 토요일까지 날짜 차이 계산
      let addedWeekCount = 6 - moment(new Date()).day();
      // 토요일에 스케줄을 등록할 경우 다음주 토요일로 스케줄을 설정한다.
      if (addedWeekCount === 0) {
        addedWeekCount += 7;
      }
      // 현재 시간 기준 다음 스케줄링 시간 (predict_datetime) - LTPD는 매주 토요일마다 자동 실행
      // predict_datetime = 토요일마다 실행이지만 자바 시간 차이로 + 1일 더해서 값을 추가하도록한다. 하지만 UI에선 실제 토요일로 표현하도록 한다 (2020.03.25 - BE 피드백 - Song)
      const nextExecuteTime = moment(removeTime(moment(new Date()))).add(addedWeekCount + 1, 'days').toDate();
      this.learnDataSet = this.setLearnDataBasePredictPeriod(this.predictPeriod, 'M', nextExecuteTime);
      const learnDateArray = predictPerfUtil.convertLearnDataSetToDateStringArray(this.learnDataSet, null);
      const predictParams = {
        trainDataList: learnDateArray,
        predictDateTimePeriod: predictPerfUtil.convertToDays(this.predictPeriod, 'M'),
        isOnDemand: false,
      };
      const params = {
        predictDatetime: nextExecuteTime,
        learnDataSet: JSON.stringify(this.learnDataSet),
        learnDataSetRaw: JSON.stringify(predictParams),
        learnDataSetLabel: predictPerfUtil.getLearnDataSetLabel(this.learnDataSet),
        eventRptPredictFlag: 'Y',
        scheduleRepeatFlag: this.scheduleApplyFlag,
        // 서비스단에서 predictDateStartTime, predictDateTimeInterval, hashkeyId 추가
      };
      EventRptApi.setEventRptSchedule(params).then((response) => {
        if (response.data.success) {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '예측 자원 스케줄 설정', true));
          this.$emit('reload');
          this.close();
        } else {
          this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '예측 자원 스케줄 설정', false));
        }
      });
    },
    /**
     * 예측기간 - 설정 값에 해당하는 기간 표시
     * @author Song
     */
    onPredictPeriodChange(value) {
      // 선택 개월 수에 따른 날짜 계산
      const defaultDateFormat = 'YYYY-MM-DD';
      this.predictDatetimeRange = `${getDateToString(moment(new Date()).add(3, 'days'), defaultDateFormat)} ~ ${getDateToString(moment(new Date()).add(2, 'days').add(value, 'month'), defaultDateFormat)}`;
    },
    /**
     * 변경한 예측 기간에 맞게 데이터를 가공, 설정한다.
     * @author Song
     */
    setLearnDataBasePredictPeriod(predictPeriod, predictPeriodUnit, nextExecuteTime) {
      // 예측날짜 -1일로 계산 (BE 요청에따라 +1일 했었으니 -2로 계산한다.)
      const targetDate = moment(removeTime(moment(nextExecuteTime).subtract(2, 'days'))).toDate();
      const recommendLearnDayCount = predictPerfUtil.getRecommendLearnDayCount(predictPeriod, predictPeriodUnit);
      const minLearnDate = predictPerfUtil.getMinDateByPredictPeriod(this.dataStoragePeriodBasicinfo,
        removeTime(targetDate), predictPeriod, predictPeriodUnit);
      // 학습 데이터 설정
      const endDatetime = cloneDeep(targetDate);
      let startDatetime = moment(endDatetime)
        .subtract(recommendLearnDayCount - 1, 'd')
        .toDate();
      if (startDatetime < minLearnDate) {
        startDatetime = minLearnDate;
      }
      return predictPerfUtil.addLearnData([], startDatetime, endDatetime);
    },
    /**
     * 통계 데이터 보관 주기 조회 api 함수
     * @author Song
     */
    getDataStoragePeriod() {
      // 데이터 보관 주기 조회
      predictPerfUtil
        .getDataStoragePeriodBasicinfo()
        .then((result) => {
          if (result.success) {
            this.dataStoragePeriodBasicinfo = result.data;
            // 보관주기에 따라 min, max 설정 => 3: 540 = 최소 2년, 4: 720 = 2년, 5: 900 = 3년, 6: 1080 = 3년
            this.predictMonth.max = this.dataStoragePeriodBasicinfo.year >= 3 ? 6 : 4;
            this.onPredictPeriodChange(this.predictPeriod);
          } else {
            this.dataStoragePeriodBasicinfo = result.data;
            this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데이터 보관 주기 정보', false));
          }
        })
        .catch((result) => {
          this.dataStoragePeriodBasicinfo = result.data;
          this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '데이터 보관 주기 정보', false));
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/event/components/popup/PredictAnalysisScheduleSettingPopup.vue